{
  "save": "Save",
  "cancel": "Cancel",
  "edit": "Edit",
  "delete": "Delete",
  "create": "Create",
  "apply": "Apply",
  "preview": "Preview",
  "label": "Label",
  "confirm": "Confirm",
  "close": "Close",
  "accept": "Accept",
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "changesSaved": "Changes saved successfully",
  "errorOccurred": "An error occurred",
  "name": "Name",
  "email": "Email",
  "password": "Password",
  "description": "Description",
  "title": "Title",
  "image": "Image",
  "file": "File",
  "required": "This field is required",
  "invalidEmail": "Invalid email address",
  "invalidPassword": "Invalid password",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "linkedin": "LinkedIn",
  "reddit": "Reddit",
  "tiktok": "TikTok",
  "x": "X (Twitter)",
  "youtube": "YouTube",
  "website": "Website",
  "workspaceInviteAccept": {
    "brandAria": "Socialize home",
    "eyebrow": "Workspace invite",
    "title": "Join {workspace} in Socialize",
    "description": "Sign in or create an account with the invited email to accept this workspace invitation.",
    "signedInDescription": "We are accepting your invite and preparing your workspace access.",
    "acceptingTitle": "Accepting your invite",
    "acceptingDescription": "We are adding this workspace to your account and refreshing your access.",
    "acceptedTitle": "Invite accepted",
    "acceptedDescription": "This workspace is already connected to your account.",
    "cancelledTitle": "Invite no longer available",
    "cancelledDescription": "This invite was cancelled by a workspace manager.",
    "mismatchTitle": "Use the invited email",
    "mismatchDescription": "This invite can only be accepted by the email address shown below. Sign in with that account, then open the invite again.",
    "notFoundTitle": "Invite not found",
    "notFoundDescription": "This invite link is invalid or no longer available.",
    "workspace": "Workspace",
    "email": "Invited email",
    "role": "Role",
    "signIn": "Sign in",
    "createAccount": "Create account",
    "acceptInvite": "Try again",
    "openApp": "Open app"
  },
  "organizationInviteAccept": {
    "brandAria": "Socialize home",
    "eyebrow": "Organization invite",
    "title": "Join {organization} in Socialize",
    "description": "Sign in or create an account with the invited email to accept this organization invitation.",
    "signedInDescription": "We are accepting your invite and preparing your organization access.",
    "acceptingTitle": "Accepting your invite",
    "acceptingDescription": "We are adding this organization to your account and refreshing your access.",
    "acceptedTitle": "Invite accepted",
    "acceptedDescription": "This organization is already connected to your account.",
    "cancelledTitle": "Invite no longer available",
    "cancelledDescription": "This invite was cancelled by an organization manager.",
    "mismatchTitle": "Use the invited email",
    "mismatchDescription": "This invite can only be accepted by the email address shown below. Sign in with that account, then open the invite again.",
    "notFoundTitle": "Invite not found",
    "notFoundDescription": "This invite link is invalid or no longer available.",
    "organization": "Organization",
    "email": "Invited email",
    "role": "Role",
    "signIn": "Sign in",
    "createAccount": "Create account",
    "acceptInvite": "Try again",
    "openApp": "Open app"
  },
  "public": {
    "nav": {
      "product": "Product",
      "pricing": "Pricing",
      "resources": "Resources",
      "blogs": "Blogs",
      "guides": "Guides",
      "ariaLabel": "Public site navigation",
      "language": "Language",
      "openApp": "Open app",
      "login": "Login"
    },
    "landing": {
      "meta": {
        "title": "BrioSocialize — Social media content review and approval",
        "description": "Try BrioSocialize to centralize social media content review, revisions, client approvals, and publication handoff in one workflow."
      },
      "hero": {
        "eyebrow": "Client approvals without the chase",
        "title": "Get social content approved before another deadline slips.",
        "description": "Stop hunting through file links, email threads, chat comments, and spreadsheets. BrioSocialize gives agencies and content teams one focused workflow for review, revisions, approvals, and publishing handoff.",
        "primaryAction": "Try the app",
        "secondaryAction": "Try the app",
        "ctaNote": "Start with your next client review. No publishing migration required."
      },
      "proof": {
        "reviews": {
          "value": "1 place",
          "label": "for every review"
        },
        "handoff": {
          "value": "0 guesswork",
          "label": "at publishing handoff"
        },
        "traceability": {
          "value": "Full context",
          "label": "for every approval"
        }
      },
      "mockup": {
        "title": "Review queue",
        "badge": "Live workflow",
        "reel": {
          "title": "May launch reel",
          "meta": "Instagram · Client review",
          "status": "Needs approval"
        },
        "launch": {
          "title": "Product announcement",
          "meta": "LinkedIn · Internal review",
          "status": "Changes logged"
        },
        "newsletter": {
          "title": "June newsletter",
          "meta": "Email · Ready for handoff",
          "status": "Approved"
        },
        "approvalLabel": "Latest decision",
        "approvalValue": "Approved version is clear, traceable, and ready to schedule."
      },
      "pillars": {
        "singleSource": {
          "eyebrow": "End the status meeting",
          "title": "Every comment, revision, decision, and due date stays attached to the content item."
        },
        "collaboration": {
          "eyebrow": "Collaboration that closes loops",
          "title": "Give agency teams, providers, and client approvers one obvious place to review and approve."
        },
        "ownership": {
          "eyebrow": "Keep ownership of your data",
          "title": "Keep client files where they belong while BrioSocialize organizes the workflow around them."
        }
      },
      "focus": {
        "eyebrow": "Why teams try it",
        "title": "The fastest way to feel the difference is to run one real approval through BrioSocialize.",
        "workspaces": {
          "label": "Workspaces",
          "description": "Keep each brand or business in a clean review workspace"
        },
        "campaigns": {
          "label": "Campaigns",
          "description": "Group related work around timelines, approvals, and delivery goals"
        },
        "contentItems": {
          "label": "Content items",
          "description": "Make every post, asset, and approval easy to find again"
        }
      },
      "finalCta": {
        "eyebrow": "Try it on your next approval",
        "title": "You already have content waiting for feedback. Put the next one in BrioSocialize.",
        "description": "Bring one client review into a workspace and see how much easier it is when feedback, versions, and approvals stay together."
      }
    },
    "product": {
      "meta": {
        "title": "BrioSocialize product — Plan, review, and approve social content",
        "description": "BrioSocialize keeps content items, assets, revisions, comments, approval decisions, and publishing handoff details in one workspace."
      },
      "eyebrow": "Product",
      "title": "Social media content approval, organized around the work itself.",
      "description": "BrioSocialize keeps content items, assets, revisions, comments, approval decisions, and publishing handoff details in one workspace so teams do not have to coordinate review across scattered tools.",
      "featureEyebrow": "Features",
      "featureTitle": "Follow the work from request to approval."
    },
    "features": {
      "content-planning": {
        "title": "Content planning",
        "description": "Shape upcoming work around clients, campaigns, channels, owners, and due dates.",
        "detailTitle": "Plan social content before review starts.",
        "detailDescription": "Create content items with the context reviewers need: copy, channels, timing, campaign relationships, and production notes.",
        "bullets": [
          "Organize work by workspace, client, and campaign.",
          "Track planned dates, channels, and review readiness.",
          "Keep the request, brief, and reviewable content together."
        ]
      },
      "asset-revisions": {
        "title": "Asset revisions",
        "description": "Keep files and versions traceable without forcing teams to abandon their storage.",
        "detailTitle": "Make the latest asset version obvious.",
        "detailDescription": "Link creative assets, preserve revision history, and keep feedback connected to the version being reviewed.",
        "bullets": [
          "Attach images, videos, documents, and file references.",
          "Preserve earlier revisions instead of overwriting context.",
          "Help reviewers understand which version is current."
        ]
      },
      "comment-threads": {
        "title": "Comment threads",
        "description": "Keep feedback attached to the content instead of scattered across chat and email.",
        "detailTitle": "Put review conversations where the work lives.",
        "detailDescription": "Centralize feedback, questions, internal notes, and client comments around the content item.",
        "bullets": [
          "Keep discussion tied to the relevant item or revision.",
          "Separate workflow comments from formal approval decisions.",
          "Reduce follow-up by keeping context visible to the team."
        ]
      },
      "approval-workflows": {
        "title": "Approval workflows",
        "description": "Record clear approval decisions before content moves to publishing handoff.",
        "detailTitle": "Turn review into a clear decision.",
        "detailDescription": "Support required, optional, and multi-step approval patterns so teams know when content is actually approved.",
        "bullets": [
          "Track who approved and when.",
          "Support internal review before client approval.",
          "Keep approval state separate from informal feedback."
        ]
      },
      "client-review": {
        "title": "Client review",
        "description": "Give external approvers a focused way to review content without full workspace access.",
        "detailTitle": "Make client review easier to complete.",
        "detailDescription": "Share focused review access so clients can comment and approve the content they are responsible for.",
        "bullets": [
          "Keep clients focused on the content they need to review.",
          "Avoid exposing internal workspace details.",
          "Reduce back-and-forth with a clear approval surface."
        ]
      },
      "review-queues": {
        "title": "Review queues",
        "description": "Show teams what needs attention, what is blocked, and what can move forward.",
        "detailTitle": "Know what needs review next.",
        "detailDescription": "Surface pending approvals, overdue work, and items waiting for feedback so teams can act quickly.",
        "bullets": [
          "Track items waiting on internal or client review.",
          "Spot blockers before deadlines slip.",
          "Keep approval work visible across the workspace."
        ]
      },
      "audit-trail": {
        "title": "Audit trail",
        "description": "Preserve the history of uploads, comments, status changes, and approvals.",
        "detailTitle": "Keep a record teams can trust.",
        "detailDescription": "BrioSocialize keeps workflow history attached to the content item so decisions and revisions remain traceable.",
        "bullets": [
          "See status changes and approval history.",
          "Preserve revision context after content changes.",
          "Make handoff decisions easier to verify."
        ]
      },
      "workspace-access": {
        "title": "Workspace access",
        "description": "Separate organization members, workspace collaborators, clients, and approvers.",
        "detailTitle": "Give the right people the right scope.",
        "detailDescription": "Use workspaces as the brand or client boundary while keeping organization access, collaborators, and external reviewers distinct.",
        "bullets": [
          "Keep each client or brand in its own workspace.",
          "Invite external collaborators without making them organization members.",
          "Preserve workspace-level scoping for review data."
        ]
      },
      "team-collaboration": {
        "title": "Team collaboration",
        "description": "Coordinate agencies, producers, providers, and client approvers in one workflow.",
        "detailTitle": "Bring every reviewer into one workflow.",
        "detailDescription": "Help internal teams, production partners, and clients work from the same review state without losing ownership of their part of the process.",
        "bullets": [
          "Coordinate internal and external contributors.",
          "Keep team review and client review connected.",
          "Make ownership and next steps easier to see."
        ]
      }
    },
    "pricing": {
      "meta": {
        "title": "BrioSocialize pricing — Plans for freelancers, agencies, and teams",
        "description": "BrioSocialize pricing for freelancers, agencies, and teams managing social media content approvals with clients."
      },
      "eyebrow": "Pricing",
      "title": "Start free. Upgrade when approvals become client work.",
      "description": "Choose the plan that matches your review volume. Every tier keeps content, feedback, revisions, and approvals in one workflow.",
      "bestValue": "Best value",
      "includedLabel": "Included",
      "limitsLabel": "Limits",
      "tiers": {
        "free": {
          "name": "Free",
          "description": "For trying BrioSocialize on one real approval workflow.",
          "price": "$0",
          "priceNote": "forever",
          "action": "Try the app",
          "features": [
            "Content items with copy and asset links",
            "Basic comments and review history",
            "One approval workflow",
            "Client-ready review view",
            "Email-ready handoff notes"
          ],
          "limits": ["1 workspace", "3 active content items", "2 team members", "1 external reviewer"]
        },
        "freelance": {
          "name": "Freelance",
          "description": "For solo operators managing recurring client reviews.",
          "price": "$19",
          "priceNote": "per month",
          "action": "Start Freelance",
          "features": [
            "Everything in Free",
            "Revision tracking for assets and copy",
            "Reusable client approval workflow",
            "Review queue for active work",
            "Activity history for approvals"
          ],
          "limits": ["3 workspaces", "25 active content items", "5 team members", "10 external reviewers"]
        },
        "agency": {
          "name": "Agency",
          "description": "For agencies that need repeatable client approval operations.",
          "price": "$79",
          "priceNote": "per month",
          "action": "Start Agency",
          "features": [
            "Everything in Freelance",
            "Multi-client workspace management",
            "Internal review before client approval",
            "Multi-step approval workflows",
            "Priority review queues and audit trail"
          ],
          "limits": ["15 workspaces", "250 active content items", "25 team members", "Unlimited external reviewers"]
        },
        "enterprise": {
          "name": "Enterprise",
          "description": "For larger organizations with governance and access needs.",
          "price": "Custom",
          "priceNote": "tailored plan",
          "action": "Start Enterprise",
          "features": [
            "Everything in Agency",
            "Organization-level access controls",
            "Advanced approval configuration",
            "Dedicated onboarding support",
            "Custom usage and workspace limits"
          ],
          "limits": [
            "Unlimited workspaces",
            "Unlimited active content items",
            "Custom member limits",
            "Custom reviewer limits"
          ]
        }
      }
    },
    "blogs": {
      "meta": {
        "title": "BrioSocialize blog — Content review and approval workflows",
        "description": "Practical articles on content review workflows, client approval, revision tracking, and publication handoff."
      },
      "eyebrow": "Blogs",
      "title": "Practical notes on content review workflows.",
      "description": "Practical articles from Brio Conception inc. about approval operations, client review habits, revision tracking, and publication handoff."
    },
    "guides": {
      "meta": {
        "title": "BrioSocialize guides — Practical content workflow playbooks",
        "description": "Reusable guides for content intake, review rounds, approval decisions, and delivery readiness."
      },
      "eyebrow": "Guides",
      "title": "Reusable guides for managing review and approval work.",
      "description": "Use these detailed playbooks for content intake, review rounds, approval decisions, version control, and publication readiness."
    },
    "terms": {
      "meta": {
        "title": "BrioSocialize Terms of Service",
        "description": "Terms of Service for using BrioSocialize's social media content review, approval, and publication handoff platform."
      },
      "eyebrow": "Legal",
      "title": "Terms of Service",
      "description": "These terms govern access to BrioSocialize, a professional workflow platform for social media content planning, review, approval, and publication handoff.",
      "effectiveDate": "Effective date: June 18, 2026",
      "sections": [
        {
          "title": "1. Agreement to these terms",
          "paragraphs": [
            "By creating an account, accepting an invitation, signing in, or using BrioSocialize, you agree to these Terms of Service. If you use BrioSocialize for an organization, client, agency, or other entity, you represent that you are authorized to bind that entity and its authorized users.",
            "If you do not agree to these terms, you must not access or use BrioSocialize."
          ]
        },
        {
          "title": "2. The service",
          "paragraphs": [
            "BrioSocialize is not a public social network. It is a workspace-based SaaS application for internal teams, providers, and client approvers coordinating social media content before publication.",
            "The service may include organizations, workspaces, channels, calendar context, content items, asset references, comments, approval decisions, notifications, social login, provider connections, and publication handoff tools."
          ]
        },
        {
          "title": "3. Accounts and authorized users",
          "paragraphs": [
            "You must provide accurate account information, keep credentials secure, and promptly notify BrioSocialize of suspected unauthorized access. You are responsible for activity under your account except to the extent caused by BrioSocialize's breach of these terms.",
            "Administrators are responsible for inviting users, assigning roles, controlling workspace access, removing users who no longer need access, and ensuring that external reviewers are authorized to see the content shared with them."
          ]
        },
        {
          "title": "4. Customer content",
          "paragraphs": [
            "Customer content means content, copy, comments, approvals, files, links, metadata, workspace settings, channel settings, and other materials submitted to or processed through BrioSocialize by users. As between you and BrioSocialize, you retain ownership of customer content.",
            "You grant BrioSocialize a limited, worldwide, non-exclusive licence to host, process, transmit, display, reproduce, and create technical copies of customer content solely as necessary to provide, secure, maintain, support, and improve the service."
          ],
          "items": [
            "You are responsible for having all rights, permissions, and legal bases needed to submit customer content.",
            "You must not submit content that is unlawful, infringing, deceptive, defamatory, harassing, malicious, or designed to compromise systems.",
            "BrioSocialize may remove or restrict access to content when reasonably necessary to comply with law, protect the service, or address a credible rights or safety concern."
          ]
        },
        {
          "title": "5. Acceptable use",
          "paragraphs": [
            "You must use BrioSocialize only for lawful business and professional purposes. You must not misuse the service or interfere with its operation."
          ],
          "items": [
            "Do not attempt to bypass authentication, authorization, rate limits, security controls, or workspace boundaries.",
            "Do not reverse engineer, scrape, overload, probe, or disrupt the service except as expressly authorized in writing.",
            "Do not use BrioSocialize to send spam, malware, abusive communications, or content that violates the rights of others.",
            "Do not share access tokens, provider credentials, or confidential workspace information with unauthorized persons."
          ]
        },
        {
          "title": "6. Third-party services and social platforms",
          "paragraphs": [
            "BrioSocialize may connect to or help organize work for third-party platforms such as social networks, identity providers, calendar providers, email providers, storage providers, analytics tools, hosting services, and payment providers. Third-party services are governed by their own terms and policies.",
            "You are responsible for complying with the rules of any social platform or third-party service you connect, including platform terms, content policies, advertising rules, API limits, permissions, and review requirements. BrioSocialize is not responsible for third-party outages, platform decisions, removed content, rejected posts, or changes to third-party APIs."
          ]
        },
        {
          "title": "7. Fees and subscriptions",
          "paragraphs": [
            "Some features may be offered free of charge and others may require a paid subscription. Prices, usage limits, taxes, renewal terms, and cancellation rules will be presented in the applicable order, checkout, invoice, or plan documentation.",
            "Unless a separate written agreement says otherwise, fees are non-refundable except where required by law or expressly stated at purchase."
          ]
        },
        {
          "title": "8. Confidentiality and security",
          "paragraphs": [
            "Each party may receive confidential information from the other. The receiving party must use reasonable care to protect confidential information and may use it only to perform obligations or exercise rights under these terms.",
            "BrioSocialize uses administrative, technical, and organizational safeguards designed to protect the service. No online service can guarantee absolute security. You remain responsible for configuring access carefully and for protecting endpoints, credentials, and connected accounts."
          ]
        },
        {
          "title": "9. Intellectual property",
          "paragraphs": [
            "BrioSocialize and its licensors retain all rights in the service, software, interfaces, workflows, designs, documentation, trademarks, and related technology. These terms do not transfer ownership of BrioSocialize technology to you.",
            "Feedback, suggestions, or ideas you provide may be used by BrioSocialize without restriction or compensation, provided BrioSocialize does not disclose your confidential information in doing so."
          ]
        },
        {
          "title": "10. Beta features and availability",
          "paragraphs": [
            "BrioSocialize may provide beta, preview, experimental, or early-access features. Those features may be changed, suspended, or discontinued at any time and may be subject to additional limits.",
            "BrioSocialize aims to provide a reliable service, but availability may be affected by maintenance, upgrades, security work, third-party dependencies, internet conditions, or events outside reasonable control."
          ]
        },
        {
          "title": "11. Suspension and termination",
          "paragraphs": [
            "You may stop using BrioSocialize at any time. BrioSocialize may suspend or terminate access if you materially breach these terms, create security or legal risk, fail to pay required fees, or use the service in a way that may harm BrioSocialize, users, or third parties.",
            "After termination, BrioSocialize may retain, delete, or export customer content according to the Privacy Policy, any applicable order or written agreement, and legal retention requirements."
          ]
        },
        {
          "title": "12. Disclaimers",
          "paragraphs": [
            "To the maximum extent permitted by law, BrioSocialize is provided on an as-is and as-available basis. BrioSocialize disclaims implied warranties of merchantability, fitness for a particular purpose, non-infringement, uninterrupted operation, and error-free operation.",
            "BrioSocialize does not provide legal, regulatory, advertising, professional, or platform-compliance advice. You are responsible for reviewing content, approvals, publishing decisions, and legal compliance before publication."
          ]
        },
        {
          "title": "13. Limitation of liability",
          "paragraphs": [
            "To the maximum extent permitted by law, BrioSocialize will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, or for lost profits, lost revenue, lost goodwill, lost data, business interruption, or substitute services.",
            "To the maximum extent permitted by law, BrioSocialize's aggregate liability arising out of or relating to the service or these terms will not exceed the amounts paid by you to BrioSocialize for the service during the twelve months before the event giving rise to liability, or CAD $100 if no amounts were paid."
          ]
        },
        {
          "title": "14. Indemnity",
          "paragraphs": [
            "You will defend, indemnify, and hold harmless BrioSocialize from claims, damages, liabilities, costs, and expenses arising from customer content, your use of the service, your breach of these terms, your violation of law, or your violation of third-party rights."
          ]
        },
        {
          "title": "15. Governing law and disputes",
          "paragraphs": [
            "Unless a separate written agreement states otherwise, these terms are governed by the laws of Canada and the laws of the Canadian province or territory where BrioSocialize's operator has its principal establishment, without regard to conflict-of-laws rules.",
            "The parties will first attempt to resolve disputes in good faith. If a dispute cannot be resolved informally, it must be brought in the courts located in that province or territory, except where applicable law gives you a mandatory right to bring a claim elsewhere."
          ]
        },
        {
          "title": "16. Changes to these terms",
          "paragraphs": [
            "BrioSocialize may update these terms from time to time. Material changes will be communicated by reasonable means, such as posting an updated version, in-product notice, or email. Continued use after the effective date of updated terms means you accept the updated terms."
          ]
        },
        {
          "title": "17. Contact",
          "paragraphs": [
            "BrioSocialize is developed and operated by Brio Conception inc., 6927, rue Marie-Drouet, Trois-Rivières, Québec, G8Y 7H8, Canada. Questions about these terms may be directed to Brio Conception inc. through the contact channel available in BrioSocialize or by telephone at +1 581 999-7540."
          ]
        }
      ]
    },
    "privacy": {
      "meta": {
        "title": "BrioSocialize Privacy Policy",
        "description": "Privacy Policy explaining how BrioSocialize collects, uses, discloses, retains, and protects personal information."
      },
      "eyebrow": "Legal",
      "title": "Privacy Policy",
      "description": "This Privacy Policy explains how BrioSocialize handles personal information when people visit the public site, create accounts, join workspaces, use integrations, or interact with the service.",
      "effectiveDate": "Effective date: June 18, 2026",
      "sections": [
        {
          "title": "1. Scope",
          "paragraphs": [
            "This policy applies to BrioSocialize's websites, application, public pages, authentication flows, support interactions, and related services. It does not apply to third-party platforms, social networks, identity providers, calendar services, payment processors, or other services that are governed by their own privacy policies.",
            "BrioSocialize is designed for business and professional use. It is not directed to children under 13, and users must not invite children to use the service unless a lawful basis and all required consents are in place."
          ]
        },
        {
          "title": "2. Personal information we collect",
          "paragraphs": [
            "The information we collect depends on how you use BrioSocialize and what your organization configures."
          ],
          "items": [
            "Account information, such as name, email address, password authentication data, profile settings, locale, and verification status.",
            "Organization and workspace information, such as roles, memberships, invitations, permissions, workspace names, channel settings, audit history, and activity records.",
            "Content and collaboration information, such as content items, comments, approval decisions, asset metadata, file references, planned dates, publication handoff details, and notification preferences.",
            "Integration information, such as social login identifiers, provider account metadata, channel identifiers, calendar source metadata, access tokens, refresh tokens, permission scopes, and connection status where an integration is enabled.",
            "Technical information, such as IP address, device and browser information, log data, diagnostic events, security events, error reports, cookies, session identifiers, and approximate location derived from network information.",
            "Support and communication information, such as messages, feedback reports, screenshots voluntarily submitted, and correspondence with BrioSocialize."
          ]
        },
        {
          "title": "3. How we use personal information",
          "paragraphs": [
            "BrioSocialize uses personal information for purposes that are necessary or reasonably expected in operating a professional workflow service."
          ],
          "items": [
            "To create accounts, authenticate users, maintain sessions, verify email addresses, and recover passwords.",
            "To provide organizations, workspaces, content review, comments, approvals, notifications, asset references, calendar context, and publication handoff workflows.",
            "To connect and maintain integrations that users or administrators choose to enable.",
            "To secure the service, prevent abuse, investigate suspicious activity, debug errors, and enforce terms and permissions.",
            "To communicate about accounts, invitations, workflow activity, service updates, security issues, support requests, and administrative matters.",
            "To analyze service performance, improve product quality, develop features, and understand usage in a manner appropriate to the nature of the service.",
            "To comply with legal obligations, preserve rights, resolve disputes, and respond to lawful requests."
          ]
        },
        {
          "title": "4. Legal bases and consent",
          "paragraphs": [
            "Depending on where you are located, BrioSocialize may rely on consent, contract performance, legitimate interests, legal obligations, or another lawful basis to collect, use, and disclose personal information.",
            "Where consent is required, you may withdraw it at any time subject to legal, contractual, security, and technical limits. Withdrawal may prevent BrioSocialize from providing features that depend on the information or integration."
          ]
        },
        {
          "title": "5. How we disclose information",
          "paragraphs": [
            "BrioSocialize does not sell personal information. We disclose personal information only as needed to provide and operate the service, as directed by users or administrators, or as permitted or required by law."
          ],
          "items": [
            "Within organizations and workspaces according to roles, permissions, invitations, comments, approvals, and configured access.",
            "To service providers that host infrastructure, store data, send email, process payments, monitor reliability, provide analytics, support security, or help operate the service.",
            "To third-party platforms and integrations when users or administrators connect accounts or request integration features.",
            "To comply with law, legal process, regulatory requests, security investigations, enforcement of terms, or protection of rights, safety, and property.",
            "In connection with a merger, acquisition, financing, restructuring, or sale of assets, subject to appropriate confidentiality and continuity protections."
          ]
        },
        {
          "title": "6. International processing",
          "paragraphs": [
            "Personal information may be processed in Canada, the United States, and other countries where BrioSocialize or its service providers operate. Those countries may have privacy laws that differ from the laws of your province, state, or country.",
            "Where required, BrioSocialize uses contractual, organizational, and technical measures intended to protect personal information during cross-border processing."
          ]
        },
        {
          "title": "7. Retention",
          "paragraphs": [
            "BrioSocialize retains personal information for as long as reasonably necessary to provide the service, maintain records, comply with legal obligations, resolve disputes, enforce agreements, protect security, and support legitimate business needs.",
            "Retention periods vary by data type. Account and workspace data may remain while an account, organization, or workspace is active. Backups and logs may persist for a limited period after deletion. Some information may be retained where required for legal, security, audit, financial, or dispute purposes."
          ]
        },
        {
          "title": "8. Security",
          "paragraphs": [
            "BrioSocialize uses reasonable administrative, technical, and organizational safeguards designed to protect personal information against unauthorized access, use, disclosure, alteration, and destruction.",
            "No system is perfectly secure. Users and administrators must protect credentials, configure workspace access carefully, remove inactive users, and avoid placing unnecessary sensitive information in content or comments."
          ]
        },
        {
          "title": "9. Cookies and similar technologies",
          "paragraphs": [
            "BrioSocialize may use cookies, local storage, session storage, and similar technologies to keep users signed in, remember preferences such as language, support security, measure performance, and operate the public site and application.",
            "Browser settings may allow you to block or delete some technologies, but doing so may affect authentication, preferences, or application functionality."
          ]
        },
        {
          "title": "10. Your privacy rights",
          "paragraphs": [
            "Depending on where you live, you may have rights to access, correct, delete, export, restrict, object to, or withdraw consent for certain personal information. You may also have the right to complain to a privacy regulator.",
            "To protect users and organizations, BrioSocialize may need to verify your identity, authority, account ownership, and workspace role before acting on a request. Some requests may be limited by legal obligations, security needs, confidential information of others, or records that must be retained."
          ]
        },
        {
          "title": "11. Account and app data deletion",
          "paragraphs": [
            "Information about deleting account or app data is available at /privacy/delete. Administrators may also remove workspace access or delete workspaces where the product permits it.",
            "Deletion may not immediately remove information from backups, security logs, financial records, legal holds, audit records, or third-party platforms that received information through integrations."
          ]
        },
        {
          "title": "12. Changes to this policy",
          "paragraphs": [
            "BrioSocialize may update this Privacy Policy from time to time. Material changes will be communicated by reasonable means, such as posting an updated version, in-product notice, or email. The effective date identifies the current version."
          ]
        },
        {
          "title": "13. Contact",
          "paragraphs": [
            "BrioSocialize is developed and operated by Brio Conception inc., 6927, rue Marie-Drouet, Trois-Rivières, Québec, G8Y 7H8, Canada. Privacy questions, access requests, correction requests, and deletion requests may be directed through the contact channel available in BrioSocialize or by telephone at +1 581 999-7540."
          ]
        }
      ]
    },
    "privacyDelete": {
      "meta": {
        "title": "BrioSocialize data deletion instructions",
        "description": "Instructions for requesting deletion of BrioSocialize account, app, workspace, and integration data."
      },
      "eyebrow": "Privacy",
      "title": "Data Deletion Instructions",
      "description": "Use this page to understand how to request deletion of account, app, workspace, and integration data associated with BrioSocialize.",
      "effectiveDate": "Effective date: June 18, 2026",
      "sections": [
        {
          "title": "1. What can be deleted",
          "paragraphs": [
            "You may request deletion of personal information associated with your BrioSocialize account, including profile information, authentication records, integration data, and personal data connected to your use of the service, subject to the limits below.",
            "Organizations and workspace administrators may also delete or remove workspace-level data where BrioSocialize provides that capability. Workspace content may belong to the organization or client that controls the workspace, so individual users may not always be able to delete organization records unilaterally."
          ]
        },
        {
          "title": "2. How to request account or app data deletion",
          "paragraphs": [
            "To request deletion, contact BrioSocialize through the contact channel made available in the app or public site. Use the email address connected to your BrioSocialize account or provide enough information for BrioSocialize to verify your identity and account ownership."
          ],
          "steps": [
            "Identify the account email address and, if relevant, the organization or workspace involved.",
            "State that you are requesting deletion of BrioSocialize account or app data.",
            "Specify whether the request concerns your personal account, a social login connection, a provider integration, a workspace invitation, or workspace content.",
            "Respond to reasonable verification requests so BrioSocialize can protect accounts and workspace records from unauthorized deletion.",
            "BrioSocialize will confirm receipt and process the request within the period required by applicable law, unless an exception or additional verification applies."
          ]
        },
        {
          "title": "3. Social login and provider integrations",
          "paragraphs": [
            "If you used Google, Facebook, or another provider to sign in or connect an account, you may also revoke BrioSocialize's access from that provider's account settings. Revoking provider access does not always delete information already stored in BrioSocialize, so you should also submit a deletion request if you want BrioSocialize-held data deleted.",
            "Deleting data in BrioSocialize does not delete posts, comments, files, messages, analytics, or account records stored by third-party platforms. You must use the applicable third-party platform tools for information held by those platforms."
          ]
        },
        {
          "title": "4. Information that may be retained",
          "paragraphs": [
            "BrioSocialize may retain certain information when retention is required or permitted for security, fraud prevention, legal compliance, financial records, audit trails, dispute resolution, backup integrity, enforcement of terms, or protection of the rights of BrioSocialize, users, organizations, or third parties."
          ],
          "items": [
            "Security logs and abuse-prevention records may be retained for a limited period.",
            "Billing, tax, payment, and accounting records may be retained as required by law.",
            "Workspace audit history, approval records, and content history may be retained where controlled by an organization or needed to preserve workflow integrity.",
            "Backups may retain deleted information until overwritten under ordinary backup cycles.",
            "Anonymized or aggregated information that no longer identifies you may be retained."
          ]
        },
        {
          "title": "5. After deletion",
          "paragraphs": [
            "After deletion is completed, you may lose access to your account, invitations, workspaces, comments, approvals, notifications, integrations, and related workflow records. Deletion may be irreversible.",
            "If your account was invited by an organization, the organization may need to invite you again before you can regain access."
          ]
        }
      ]
    }
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "creating": "Creating...",
    "next": "Next",
    "saving": "Saving..."
  },
  "workspaceSelector": {
    "createAction": "Add workspace",
    "organizationLabel": "Organization",
    "organizationSettings": "Organization settings",
    "noOrganization": "No organization",
    "workspaceSettings": "Workspace settings"
  },
  "workspaceCreate": {
    "eyebrow": "Workspace",
    "title": "Create a new workspace",
    "description": "Set up a new workspace with its own timezone, members, and workflow.",
    "formTitle": "Workspace details",
    "formDescription": "Start with the core fields now. Members and workflow can be configured right after creation.",
    "createAction": "Create workspace",
    "fields": {
      "name": "Workspace name",
      "namePlaceholder": "Northwind Studio",
      "organization": "Organization",
      "timeZone": "Time zone"
    },
    "errors": {
      "required": "All workspace fields are required.",
      "createFailed": "The workspace could not be created."
    }
  },
  "organizationOnboarding": {
    "eyebrow": "So we can tailor Socialize to your workflow",
    "title": "Tell us a bit about your team",
    "progress": "Step {current} of {total}",
    "progressLabel": "Onboarding progress",
    "finish": "Finish setup",
    "steps": {
      "organization": "Organization",
      "survey": "Team profile",
      "workspace": "Workspace / brand",
      "members": "Members",
      "channels": "Social channels",
      "approval": "Approval type"
    },
    "stepInvites": {
      "organization": "Start with the account identity your team will recognize across workspaces.",
      "survey": "Shape the setup around how your team works without storing survey data yet.",
      "workspace": "Create the first brand or client workspace where content work will happen.",
      "members": "Invite teammates, clients, or providers who should join this workspace.",
      "channels": "Add the social destinations this workspace plans, reviews, and approves.",
      "approval": "Choose how strongly content must be approved before it moves forward."
    },
    "errors": {
      "saveFailed": "This step could not be saved.",
      "unsupportedImage": "Choose a PNG, JPG, GIF, or WebP image."
    },
    "create": {
      "fields": {
        "name": "Organization name",
        "logo": "Organization logo",
        "namePlaceholder": "Northstar Agency",
        "membershipTier": "Membership tier"
      },
      "logoEditorTitle": "Edit organization logo",
      "tiers": {
        "freePrice": "Free",
        "monthlyPrice": "{price}/month",
        "customPrice": "Custom"
      },
      "errors": {
        "required": "Organization name is required.",
        "failed": "The organization could not be created."
      }
    },
    "survey": {
      "fields": {
        "peopleCount": "People count",
        "usage": "Primary usage"
      },
      "types": {
        "agency": "Agency",
        "freelance": "Freelance",
        "brand": "Brand",
        "other": "Other"
      },
      "people": {
        "one": "Just me",
        "small": "2-10 people",
        "medium": "11-50 people",
        "large": "51+ people"
      },
      "usage": {
        "review": "Content review",
        "calendar": "Planning calendar",
        "clients": "Client approvals",
        "assets": "Asset handoff"
      }
    },
    "workspace": {
      "fields": {
        "name": "Workspace or brand name",
        "namePlaceholder": "Northstar Social",
        "logo": "Workspace logo"
      },
      "logoEditorTitle": "Edit workspace logo",
      "errors": {
        "required": "Workspace name and time zone are required."
      }
    },
    "logoEditor": {
      "chooseAction": "Choose image",
      "saveAction": "Use edited image"
    },
    "members": {
      "inviteSaved": "Invite created.",
      "cancelInvite": "Cancel invite",
      "cancelFailed": "The invite could not be cancelled."
    },
    "channels": {
      "saved": "Channel created.",
      "errors": {
        "required": "Channel name is required."
      }
    },
    "approval": {
      "defaultStepName": "Manager approval"
    }
  },
  "billingSettings": {
    "loading": "Loading billing information",
    "retry": "Retry",
    "providerUnavailable": "Live payment details are temporarily unavailable. Your subscription information is still shown below.",
    "currentPlan": "Current plan",
    "comparePlans": "Compare plans",
    "transactionHistory": "Transaction history",
    "transactionDescription": "Receipts and subscription invoices.",
    "noTransactions": "No transactions yet. Paid invoices will appear here.",
    "viewAll": "View all",
    "date": "Date",
    "status": "Status",
    "amount": "Amount",
    "statuses": {
      "active": "Active",
      "trialing": "Trial",
      "pastdue": "Past due",
      "canceled": "Canceled",
      "incomplete": "Payment pending",
      "none": "Free",
      "paid": "Paid",
      "open": "Open",
      "draft": "Draft",
      "void": "Void",
      "failed": "Failed"
    },
    "billingInformation": "Billing information",
    "informationDescription": "Used for invoices and payment-provider records.",
    "edit": "Edit",
    "notProvided": "Not provided",
    "paymentMethods": "Payment methods",
    "methodsDescription": "Cards are stored securely by Stripe.",
    "addNew": "Add new",
    "default": "Default",
    "cardActions": "Actions for card ending {last4}",
    "makeDefault": "Make default",
    "remove": "Remove",
    "noPaymentMethods": "No payment method saved. Add a card before choosing a paid plan.",
    "reactivatePlan": "Reactivate plan",
    "cancelPlan": "Cancel plan",
    "keepRenewing": "Keep the plan renewing after {date}.",
    "cancelDescription": "If you cancel, access continues until the end of the current billing period.",
    "reactivate": "Reactivate",
    "cancel": "Cancel",
    "custom": "Custom",
    "free": "Free",
    "perMonth": "{price}/month",
    "unlimited": "Unlimited",
    "overLimit": "Current {usage} usage ({used}) exceeds this plan's limit ({limit}). The change can still be scheduled, but new usage will be blocked once it takes effect.",
    "contactUs": "Contact us",
    "choosePlan": "Choose plan",
    "planUnavailable": "Temporarily unavailable",
    "planUnavailableDescription": "This paid plan is temporarily unavailable while its payment-provider Price is configured.",
    "close": "Close",
    "editInformation": "Edit billing information",
    "save": "Save",
    "addPaymentMethod": "Add payment method",
    "secureCardDescription": "Card details go directly to Stripe and never pass through Socialize.",
    "saveCard": "Save card",
    "cancelQuestion": "Cancel {plan}?",
    "cancelDialogDescription": "Plan access remains available through {date}. The organization then returns to Free limits.",
    "keepPlan": "Keep plan",
    "scheduleCancellation": "Schedule cancellation",
    "loadMore": "Load more",
    "confirmRemove": "Remove {brand} ending in {last4}?",
    "fields": {
      "email": "Billing email",
      "name": "Name",
      "address": "Address",
      "companyName": "Name or company",
      "addressLine1": "Address line 1",
      "addressLine2": "Address line 2",
      "city": "City",
      "region": "Province or state",
      "postalCode": "Postal code",
      "countryCode": "Country code"
    },
    "limits": {
      "workspaces": "{count} workspaces",
      "members": "{count} members",
      "activeContent": "{count} active content items",
      "externalReviewers": "{count} external reviewers"
    },
    "messages": {
      "accessUntil": "Access continues until {date}.",
      "changesOn": "Changes to {plan} on {date}.",
      "pastDue": "Payment is past due. Update your card before {date}.",
      "confirmPayment": "Payment confirmation is required before the paid plan becomes active.",
      "renewsOn": "Renews on {date}.",
      "upgrade": "Upgrade when your organization needs more capacity.",
      "informationSaved": "Billing information saved.",
      "methodAdded": "Payment method added.",
      "planScheduled": "Plan change scheduled.",
      "planUpdated": "Plan updated.",
      "cancellationScheduled": "Cancellation scheduled.",
      "reactivated": "Subscription reactivated.",
      "defaultUpdated": "Default payment method updated.",
      "methodRemoved": "Payment method removed."
    },
    "errors": {
      "stripeLoad": "Stripe.js could not be loaded.",
      "confirmationLoad": "Secure payment confirmation could not be loaded. Please try again.",
      "setupFailed": "The payment method could not be saved. Check the card details and try again."
    }
  },
  "organizationSettings": {
    "eyebrow": "Organization",
    "title": "Organization settings",
    "description": "Manage the SaaS account boundary for members, usage, and billing access.",
    "loading": "Loading organization settings...",
    "saving": "Saving...",
    "saveProfile": "Save profile",
    "editName": "Edit organization name",
    "saveName": "Save organization name",
    "cancelNameEdit": "Cancel name edit",
    "profileSaved": "Organization profile saved.",
    "addMember": "Add member",
    "addingMember": "Adding...",
    "memberAdded": "Organization member added.",
    "sendInvite": "Send invite",
    "sendingInvite": "Sending...",
    "inviteSent": "Organization invite sent.",
    "cancelInvite": "Cancel invite",
    "inviteCancelled": "Organization invite cancelled.",
    "resendInvite": "Resend email",
    "editPermissions": "Edit permissions",
    "editRole": "Edit role",
    "saveRole": "Save role",
    "roleUpdated": "Member role updated.",
    "removeMember": {
      "action": "Remove member",
      "confirm": "Remove {name} from this organization?",
      "removed": "Organization member removed."
    },
    "delete": {
      "title": "Delete organization",
      "description": "Delete this organization and all owned workspaces. This removes the organization from normal app views and cannot be undone from settings.",
      "confirmationLabel": "Type {name} to delete this organization",
      "action": "Delete organization",
      "deleting": "Deleting...",
      "confirmationMismatch": "Type the organization name exactly to delete it."
    },
    "default": {
      "action": "Make default",
      "badge": "Default organization",
      "currentAction": "Default organization",
      "saved": "Default organization updated."
    },
    "logo": {
      "title": "Organization logo",
      "description": "Shown in organization settings and switchers.",
      "changeAction": "Change logo",
      "chooseAction": "Choose logo",
      "cropperTitle": "Edit organization logo",
      "saveAction": "Save logo",
      "saving": "Saving...",
      "saved": "Organization logo saved."
    },
    "fields": {
      "name": "Name",
      "memberEmail": "Member email",
      "memberRole": "Role",
      "relationshipType": "Relationship",
      "membershipTier": "Membership tier",
      "createdAt": "Created"
    },
    "errors": {
      "nameRequired": "Organization name is required.",
      "profileSaveFailed": "The organization profile could not be saved.",
      "memberRequired": "Email and role are required to add a member.",
      "memberAddFailed": "The organization member could not be added. Existing users can be added by email.",
      "inviteRequired": "Email and role are required to invite a member.",
      "emailRequired": "Enter an email address.",
      "emailInvalid": "Enter a valid email address.",
      "inviteFailed": "The organization invite could not be sent.",
      "inviteCancelFailed": "The organization invite could not be cancelled.",
      "memberRemoveFailed": "The organization member could not be removed.",
      "roleUpdateFailed": "The member role could not be updated.",
      "defaultSaveFailed": "The default organization could not be updated.",
      "logoUploadFailed": "The organization logo could not be saved.",
      "membershipTierRequired": "Select a membership tier.",
      "tierSaveFailed": "The membership tier could not be updated.",
      "deleteFailed": "The organization could not be deleted."
    },
    "sections": {
      "profile": {
        "title": "Profile",
        "description": "The account identity used across organization-owned workspaces."
      },
      "members": {
        "title": "Members",
        "description": "Organization-level users and their inherited account permissions.",
        "inviteTitle": "Invite",
        "currentMembers": "Current members",
        "pendingInvites": "Pending invites",
        "access": "Access",
        "status": "Status",
        "inviteStatus": "{status} invite",
        "noPendingInvites": "No pending invites.",
        "empty": "No organization members found."
      },
      "usage": {
        "title": "Usage",
        "description": "Current organization usage against plan limits.",
        "planLabel": "Current plan",
        "planFallback": "No plan configured",
        "empty": "No usage data is available yet."
      },
      "billing": {
        "title": "Billing",
        "description": "Subscription and billing access for this organization.",
        "placeholderTitle": "Billing provider is not connected yet",
        "placeholderText": "Plan, payment, and invoice management will live here after billing integration is added."
      },
      "workspaces": {
        "title": "Workspaces",
        "description": "Brand and client workspaces owned by this organization.",
        "empty": "No workspaces belong to this organization yet."
      }
    },
    "usage": {
      "unlimited": "Unlimited",
      "items": {
        "users": "Users",
        "workspaces": "Workspaces",
        "activeContent": "Active content",
        "externalReviewers": "External reviewers",
        "storage": "Storage space"
      }
    },
    "tiers": {
      "freePrice": "Free",
      "monthlyPrice": "{price}/month",
      "customPrice": "Custom",
      "summary": "{price} - {workspaces} workspaces, {members} members, {activeContent} active content, {storage} storage"
    },
    "roles": {
      "Owner": "Owner",
      "Administrator": "Administrator",
      "Contributor": "Contributor",
      "Writer": "Writer",
      "Reviewer": "Reviewer",
      "Guest": "Guest",
      "Admin": "Admin",
      "BillingManager": "Billing manager",
      "ConnectorManager": "Connector manager",
      "Member": "Member"
    },
    "accessRoles": {
      "administrator": {
        "label": "Administrator",
        "description": "All permissions, including managing users, pages, comments, billing, connectors, and workspaces."
      },
      "contributor": {
        "label": "Contributor",
        "description": "Can create and edit posts and comments, then publish or schedule content."
      },
      "writer": {
        "label": "Writer",
        "description": "Can create and edit posts and comments."
      },
      "reviewer": {
        "label": "Reviewer",
        "description": "Can review and approve posts and comments."
      },
      "guest": {
        "label": "Guest",
        "description": "Can view posts and comments."
      }
    },
    "relationshipTypes": {
      "OrganizationMember": "Member",
      "ExternalCollaborator": "Collaborator",
      "Member": "Member",
      "External": "External",
      "Client": "Client"
    },
    "permissions": {
      "title": "Your permissions",
      "description": "Current organization permissions returned by the API.",
      "read": "Read",
      "write": "Write",
      "items": {
        "ManageOrganizationSettings": "Manage settings",
        "ManageOrganizationMembers": "Manage members",
        "CreateWorkspaces": "Create workspaces",
        "ManageWorkspaces": "Manage workspaces",
        "ManageBilling": "Manage billing",
        "ManageConnectors": "Manage connectors",
        "AccessOwnedWorkspaces": "Access owned workspaces"
      }
    }
  },
  "nav": {
    "brandStage": "Alpha Preview",
    "brandStageLabel": "Product stage: Alpha Preview",
    "brandCaption": "Approval workflow",
    "workspace": "Workspace",
    "notifications": "Notifications",
    "dashboard": "Dashboard",
    "overview": "Overview",
    "calendar": "Calendar",
    "workspacePlan": "Calendar",
    "mediaLibrary": "Media Library",
    "publishing": "Publishing",
    "myFeedback": "My Feedback",
    "feedbackReview": "Feedback Review",
    "whatsNew": "What's New",
    "releaseUpdates": "Release Updates",
    "releaseNotes": "Release Notes",
    "billingCatalog": "Billing Catalog",
    "channels": "Channels",
    "campaigns": "Campaigns",
    "reviewQueue": "Review Queue",
    "content": "Content",
    "profile": "Profile",
    "signIn": "Sign in",
    "settings": "Settings",
    "language": "Language",
    "signOut": "Sign out",
    "noWorkspace": "No workspace"
  },
  "developerBilling": {
    "eyebrow": "SaaS operator",
    "title": "Provider pricing",
    "description": "Link Socialize plans to validated recurring Prices from the active payment provider.",
    "boundaryNote": "Socialize remains the source of truth for plan features and amounts. {provider} Price IDs are provider references used only for future purchases.",
    "providerFallback": "Payment provider",
    "loading": "Loading provider Price mappings",
    "retry": "Retry",
    "current": "Current mapping",
    "amount": "Amount",
    "billingCycle": "Billing cycle",
    "activated": "Activated",
    "addMapping": "Add mapping",
    "changeMapping": "Change mapping",
    "retire": "Retire",
    "unmapped": "Purchases unavailable",
    "unmappedDescription": "Customers cannot start or change to this paid plan until a current provider Price is mapped.",
    "history": "Mapping history",
    "retiredOn": "Retired {date}",
    "empty": "No payment-provider Price mappings exist yet.",
    "dialogTitle": "Validate provider Price",
    "dialogDescription": "Paste an existing {provider} Price ID. Socialize verifies its active state, recurring interval, currency, and amount before activating it.",
    "priceReference": "{provider} Price ID",
    "validationNote": "Changing the mapping affects new purchases only. Existing subscriptions keep their historical Price.",
    "validateAndActivate": "Validate and activate",
    "retireTitle": "Retire this mapping?",
    "retireDescription": "New purchases for this plan will be unavailable until another Price is activated. Existing subscriptions are not changed.",
    "messages": {
      "activated": "Provider Price validated and activated.",
      "retired": "Provider Price mapping retired."
    }
  },
  "notifications": {
    "title": "Notifications",
    "unread": "unread",
    "loading": "Loading notifications...",
    "empty": "No workflow notifications yet.",
    "events": {
      "approvalRequested": "Approval requested",
      "approvalDecisionRecorded": "Approval decision recorded",
      "commentCreated": "Comment added",
      "commentResolved": "Comment resolved",
      "contentCreated": "Content item created",
      "revisionCreated": "Revision created",
      "statusUpdated": "Status updated",
      "assetLinked": "Asset linked",
      "assetRevisionCreated": "Asset revision created",
      "feedbackReportCreated": "New feedback report",
      "feedbackDeveloperCommented": "Developer commented",
      "feedbackStatusChanged": "Feedback status changed",
      "feedbackReporterCommented": "Reporter replied"
    }
  },
  "appSearch": {
    "placeholder": "Search",
    "ariaLabel": "Search content and app sections",
    "contentGroup": "Content items",
    "navigationGroup": "App",
    "loading": "Searching content...",
    "noResults": "No results found.",
    "error": "Search is unavailable."
  },
  "releaseCommunications": {
    "summary": "Summary",
    "description": "Description",
    "noteTitle": "Title",
    "english": "English",
    "french": "French",
    "titleEn": "English title",
    "descriptionEn": "English description",
    "titleFr": "French title",
    "descriptionFr": "French description",
    "body": "Body",
    "category": "Category",
    "importance": "Importance",
    "audience": "Audience",
    "deploymentLabel": "Deployment label",
    "buildVersion": "Build version",
    "commitRange": "Commit range",
    "emptyValue": "Not set",
    "errors": {
      "loadFailed": "Could not load product updates."
    },
    "user": {
      "eyebrow": "Product updates",
      "title": "What's New",
      "description": "Features, improvements, and fixes published since you last checked.",
      "markAllRead": "Mark all read",
      "empty": "No published updates yet."
    },
    "developer": {
      "eyebrow": "SaaS operator",
      "title": "Release updates",
      "description": "Create, publish, and archive curated product updates.",
      "creationTitle": "Release Note",
      "creationDescription": "Draft a release note from selected commits or edit an existing release.",
      "createReleaseNote": "Create Release Note",
      "createFirstRelease": "Create First Release",
      "noReleaseNotes": "No release notes yet.",
      "newUpdate": "New update",
      "publish": "Publish",
      "archive": "Archive",
      "forceDigest": "Send daily email",
      "forceDigestConfirm": "Send the daily release email now to every eligible user with unread updates?",
      "forceDigestResult": "Daily release email sent to {count} users.",
      "linkedCommits": "Linked commits",
      "noLinkedCommits": "No commits linked to this update yet."
    },
    "commits": {
      "eyebrow": "SaaS operator",
      "title": "Release notes",
      "description": "Review pending commits and maintain the release note history.",
      "gitLogTab": "Changes",
      "releaseNotesTab": "History",
      "refresh": "Refresh",
      "exclude": "Exclude",
      "unreviewed": "unreviewed",
      "branch": "Branch or ref",
      "limit": "Limit",
      "since": "Since",
      "until": "Until",
      "fetch": "Fetch commits",
      "importResult": "Imported {imported}, updated {updated}, skipped {skipped}.",
      "search": "Search",
      "status": "Status",
      "linkedUpdate": "Linked update",
      "releaseNote": "Release note",
      "notIncluded": "Not included",
      "inclusion": {
        "label": "Release note status",
        "notIncluded": "Not in a release note",
        "included": "In a release note",
        "all": "All commits"
      },
      "author": "Author",
      "sha": "SHA",
      "commit": "Commit",
      "committed": "Committed",
      "actions": "Actions",
      "empty": "No commits match the current filters.",
      "clear": "Clear",
      "link": "Update",
      "selected": "{count} selected",
      "selectCommit": "Select commit",
      "copied": "Copied.",
      "createUpdate": "Create release note",
      "selectedCommits": "Selected commits",
      "internalOnly": "Internal only",
      "ignore": "Ignore"
    }
  },
  "feedback": {
    "button": "Feedback",
    "open": "Send product feedback",
    "eyebrow": "Product feedback",
    "title": "Send feedback",
    "capture": "Capture screen",
    "removeCapture": "Remove capture",
    "noCapture": "Capture the current app viewport if a screenshot would help.",
    "captureFailed": "The screenshot could not be captured. You can still submit feedback without it.",
    "submit": "Submit feedback",
    "submitted": "Feedback submitted.",
    "submitFailed": "Feedback could not be submitted.",
    "discardConfirm": "Discard this unsent feedback?",
    "textPrompt": "Text label",
    "types": {
      "bug": "Bug",
      "suggestion": "Suggestion",
      "request": "Request"
    },
    "fields": {
      "type": "Type",
      "description": "Description",
      "descriptionPlaceholder": "Describe what happened, what you expected, or what would improve the workflow."
    },
    "tools": {
      "crop": "Crop",
      "arrow": "Arrow",
      "ellipse": "Circle",
      "line": "Line",
      "freehand": "Freehand",
      "text": "Text label",
      "undo": "Undo",
      "clear": "Clear and reset"
    },
    "review": {
      "eyebrow": "Developer review",
      "title": "Product feedback",
      "description": "Review submitted bugs, suggestions, and requests across all workspaces.",
      "refresh": "Refresh feedback",
      "loading": "Loading feedback...",
      "empty": "No feedback matches the current filters.",
      "emptyValue": "Not captured",
      "noContext": "No workspace context",
      "lastActivity": "Last activity",
      "metrics": {
        "total": "Total reports",
        "visible": "Visible",
        "new": "New",
        "planned": "Planned"
      },
      "filters": {
        "search": "Search feedback",
        "type": "Type",
        "status": "Status",
        "tag": "Tag",
        "reporter": "Reporter",
        "workspace": "Workspace",
        "fromDate": "From date",
        "toDate": "To date",
        "sort": "Sort",
        "clear": "Clear filters"
      },
      "sort": {
        "lastActivity": "Last activity",
        "newest": "Newest",
        "oldest": "Oldest"
      },
      "errors": {
        "loadFailed": "Feedback could not be loaded.",
        "detailFailed": "The feedback report could not be loaded."
      },
      "detail": {
        "back": "Back to feedback",
        "eyebrow": "Feedback detail",
        "report": "Report",
        "screenshot": "Screenshot",
        "download": "Download original",
        "openOriginal": "Open original",
        "screenshotAlt": "Feedback screenshot",
        "noScreenshot": "No screenshot was attached.",
        "timeline": "Comments and activity",
        "noTimeline": "No comments or activity yet.",
        "commentLabel": "Developer comment",
        "addComment": "Add comment",
        "commenting": "Adding comment...",
        "commentAdded": "Comment added.",
        "commentFailed": "Comment could not be added.",
        "reviewControls": "Review controls",
        "saved": "Feedback updated.",
        "saveFailed": "Feedback could not be updated.",
        "reporter": "Reporter",
        "activityLabel": "Activity",
        "metadata": {
          "title": "Captured metadata",
          "path": "Submitted path",
          "userAgent": "Browser",
          "viewport": "Viewport",
          "appVersion": "App version",
          "created": "Created",
          "lastActivity": "Last activity"
        },
        "context": {
          "title": "Context",
          "workspace": "Workspace",
          "client": "Client",
          "campaign": "Campaign",
          "contentItem": "Content item"
        },
        "activity": {
          "updated": "Updated feedback.",
          "statusChanged": "Changed status from {from} to {to}.",
          "typeChanged": "Changed type from {from} to {to}.",
          "tagsChanged": "Changed tags from {from} to {to}."
        }
      }
    },
    "mine": {
      "eyebrow": "My feedback",
      "title": "My Feedback",
      "description": "Track the product feedback you have submitted across workspaces.",
      "refresh": "Refresh my feedback",
      "empty": "No feedback matches the current filters.",
      "unread": "Unread feedback activity",
      "metrics": {
        "active": "Active reports",
        "unread": "Unread",
        "visible": "Visible"
      },
      "errors": {
        "loadFailed": "Your feedback could not be loaded.",
        "detailFailed": "This feedback report could not be loaded."
      },
      "detail": {
        "back": "Back to my feedback",
        "eyebrow": "My feedback detail",
        "commentLabel": "Follow-up comment",
        "commentAdded": "Comment added.",
        "commentFailed": "Comment could not be added.",
        "cancel": "Cancel report",
        "cancelPrompt": "Optional cancellation reason",
        "cancelled": "Feedback cancelled.",
        "cancelFailed": "Feedback could not be cancelled."
      }
    }
  },
  "sidebar": {
    "expand": "Expand sidebar",
    "collapse": "Collapse sidebar",
    "allChannels": "All channels",
    "allCampaigns": "All campaigns",
    "allReviewItems": "Full review queue",
    "noChannels": "No channels yet.",
    "noCampaigns": "No campaigns yet.",
    "noReviewItems": "No review items right now."
  },
  "settings": {
    "eyebrow": "Settings",
    "title": "Account settings",
    "userInformation": "User information",
    "workspaces": "Workspaces"
  },
  "dashboard": {
    "eyebrow": "Workspace schedule",
    "title": "Schedule",
    "description": "See what is scheduled for a given day and review the posting agenda in order.",
    "workspaceLabel": "Active workspace",
    "loading": "Loading workspace data...",
    "calendarKicker": "Daily agenda",
    "executionKicker": "Next up",
    "riskKicker": "Delivery risk",
    "reviewKicker": "Review pulse",
    "upcomingContent": "Upcoming content",
    "deliveryRisks": "What can slip",
    "overdueItems": "Overdue items",
    "approvalBlockers": "Awaiting approval or revisions",
    "unscheduledCampaigns": "Campaigns without scheduled content",
    "reviewQueueSnapshot": "Review queue snapshot",
    "emptyUpcoming": "No upcoming scheduled content.",
    "emptyOverdue": "Nothing overdue right now.",
    "emptyApproval": "No approval blockers at the moment.",
    "emptyCampaigns": "Every campaign has at least one scheduled content item.",
    "emptyReviewQueue": "No active review queue items.",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "today": "Today",
    "day": "Day",
    "month": "Month",
    "week": "Week",
    "campaignDeadline": "Campaign deadline",
    "emptyPeriod": "No scheduled items.",
    "daySummary": "{content} content items · {campaigns} campaign deadlines",
    "moreItems": "+{count} more",
    "emptyDayAgenda": "No content is scheduled for this day.",
    "campaignProgress": "{scheduled} scheduled · {approved} approved",
    "missingSchedule": "Needs content scheduled",
    "noDueDate": "No due date",
    "labels": {
      "unassignedCampaign": "Unassigned campaign"
    },
    "readiness": {
      "building": "In production",
      "approval": "Awaiting approval",
      "rework": "Needs revision",
      "ready": "Approved",
      "published": "Published",
      "blocked": "Blocked",
      "archived": "Archived",
      "scheduled": "Scheduled",
      "missing": "No content scheduled"
    },
    "stats": {
      "scheduledThisDay": "Scheduled this day",
      "overdue": "Overdue",
      "awaitingApproval": "Awaiting approval",
      "readyToShip": "Ready to ship"
    }
  },
  "overview": {
    "eyebrow": "Portfolio overview",
    "title": "Cross-workspace timeline",
    "description": "See upcoming deliveries, risks, and activity across every workspace you can access.",
    "loading": "Loading overview data...",
    "workspacesKicker": "Access scope",
    "workspaceRollup": "Workspace rollup",
    "timelineKicker": "Upcoming",
    "upcomingTitle": "Scheduled across workspaces",
    "riskKicker": "Watch list",
    "risksTitle": "Items already at risk",
    "activityKicker": "Recent activity",
    "activityTitle": "Latest workflow events",
    "emptyUpcoming": "No upcoming scheduled items across your workspaces.",
    "emptyRisks": "No cross-workspace delivery risks right now.",
    "emptyActivity": "No recent workflow activity yet.",
    "labels": {
      "campaigns": "campaigns",
      "upcoming": "upcoming",
      "blocked": "blocked"
    },
    "stats": {
      "workspaces": "Workspaces",
      "campaigns": "Campaigns",
      "upcoming": "Upcoming items",
      "blockers": "At-risk items"
    }
  },
  "campaigns": {
    "eyebrow": "Campaign planning",
    "title": "Campaigns",
    "description": "Campaigns grouped inside the active workspace by status, date range, and planning notes.",
    "newCampaign": "New campaign",
    "createTitle": "Create campaign",
    "loading": "Loading campaigns...",
    "empty": "No campaigns are available for the active workspace.",
    "noDateRange": "No date range",
    "errors": {
      "required": "Campaign name and date range are required.",
      "invalidDateRange": "The end date must be on or after the start date.",
      "createFailed": "The campaign could not be created."
    },
    "fields": {
      "startDate": "Start date",
      "endDate": "End date",
      "name": "Campaign name",
      "description": "Description",
      "notes": "Notes"
    }
  },
  "channels": {
    "title": "Channels",
    "description": "Add channels to the workspace.",
    "createTitle": "Create channel",
    "editTitle": "Edit channel",
    "saveChanges": "Save changes",
    "empty": "No channels are available for the active workspace yet.",
    "emptyAction": "Add a channel for {network}",
    "nextDue": "Next due",
    "noScheduled": "Nothing scheduled",
    "fields": {
      "name": "Channel name",
      "network": "Network",
      "handle": "Handle",
      "externalUrl": "External URL",
      "portraitUrl": "Portrait URL",
      "bannerUrl": "Banner URL"
    },
    "actions": {
      "changePortrait": "Change portrait",
      "changeBanner": "Change banner"
    },
    "metrics": {
      "scheduled": "Scheduled",
      "ready": "Ready",
      "blocked": "Blocked"
    },
    "errors": {
      "createFailed": "The channel could not be created.",
      "updateFailed": "The channel could not be updated."
    }
  },
  "reviewQueue": {
    "eyebrow": "Review workflow",
    "title": "Review queue",
    "description": "Pending approvals, revisions, and change requests for the active workspace.",
    "empty": "No review items are available for the active workspace."
  },
  "contentItems": {
    "title": "Content items",
    "newItem": "New Content",
    "createTitle": "Create content item",
    "upcoming": "Upcoming",
    "upcomingLabels": {
      "tomorrow": "Tomorrow",
      "onePost": "1 post",
      "postCount": "{count} posts",
      "emptyTitle": "No upcoming content",
      "emptyDescription": "Scheduled posts will appear here."
    },
    "views": {
      "calendar": "Calendar",
      "table": "Table"
    },
    "table": {
      "content": "Content",
      "status": "Status",
      "channels": "Channels",
      "revision": "Revision",
      "dueDate": "Due date",
      "plannedDate": "Planned date",
      "sortByContent": "Sort by content",
      "sortByStatus": "Sort by status",
      "sortByChannels": "Sort by channels",
      "sortByRevision": "Sort by revision",
      "sortByPlannedDate": "Sort by planned date"
    },
    "loading": "Loading content items...",
    "empty": "No content items are available for the active workspace.",
    "noDueDate": "No due date",
    "assetsHelper": "Media library assets are now linked from the content item detail page after creation.",
    "channelSetupRequired": {
      "title": "Configure channels first",
      "description": "Content needs at least one workspace channel before it can be targeted, previewed, or scheduled.",
      "action": "Configure channels"
    },
    "calendar": {
      "organization": "Organization",
      "workspace": "Workspace",
      "mine": "My calendars",
      "calendars": "Calendars",
      "visibleCalendar": "{count} calendar",
      "visibleCalendars": "{count} calendars",
      "noCalendars": "No calendars available.",
      "addCalendar": "Add calendar",
      "removeCalendar": "Remove calendar",
      "removeCalendarNamed": "Remove {name}",
      "removeConfirm": "Remove {name} from external calendars?",
      "alreadyAdded": "Already added",
      "catalog": "Catalog",
      "customIcs": "Custom ICS",
      "searchCatalog": "Search calendars",
      "search": "Search",
      "country": "Country",
      "category": "Category",
      "calendarName": "Calendar name",
      "icsUrl": "ICS URL",
      "editColor": "Edit calendar color",
      "allDay": "All day",
      "context": "Calendar context",
      "importedEvent": "Imported calendar",
      "month": "Month",
      "previousWeek": "Previous week",
      "nextWeek": "Next week",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "previousYear": "Previous year",
      "nextYear": "Next year",
      "errors": {
        "required": "Calendar name and URL are required.",
        "duplicate": "This calendar has already been added.",
        "createFailed": "The calendar could not be added.",
        "deleteFailed": "The calendar could not be removed."
      }
    },
    "dateContext": {
      "noEvents": "No visible calendar events for this date.",
      "viewDay": "View day"
    },
    "errors": {
      "required": "Title, campaign, message, and targets are required.",
      "workspaceAccountRequired": "This workspace needs an operational account before content can be created.",
      "createFailed": "The content item could not be created."
    },
    "fields": {
      "title": "Title",
      "client": "Client",
      "selectClient": "Select a client",
      "campaign": "Campaign",
      "selectCampaign": "Select a campaign",
      "dueDate": "Due date",
      "publicationTargets": "Publication targets",
      "publicationMessage": "Publication message",
      "hashtags": "Hashtags",
      "hashtagsPlaceholder": "#launch #brand #campaign",
      "assets": "Assets"
    },
    "workflow": {
      "ariaLabel": "Content workflow",
      "title": "Workflow",
      "loadingDetail": "Loading content item...",
      "saveFirst": "Save the content first to see workflow steps.",
      "steps": {
        "intake": "Brief",
        "brainstorm": "Brainstorm / Storyboard",
        "production": "Production",
        "content": "Content",
        "planning": "Planning",
        "publish": "Publish",
        "schedule": "Scheduling",
        "approval": "Approval"
      },
      "states": {
        "skipped": "Skipped",
        "notNeeded": "Not needed",
        "pending": "Pending",
        "draft": "Draft",
        "inApproval": "In approval",
        "approved": "Approved",
        "scheduled": "Scheduled",
        "published": "Published",
        "inProduction": "In production",
        "requestChanges": "Changes requested",
        "rejected": "Rejected"
      },
      "meta": {
        "productionRequestsScoped": "{count} production request(s) scoped",
        "productionNeeded": "Production work needed",
        "productionNotNeeded": "No production work needed",
        "intakeReady": "Brief ready",
        "intakeDraft": "Title needed",
        "channels": "{count} channel(s)",
        "noDate": "No date",
        "approvalDisabled": "Approval is disabled for this workspace.",
        "waitingOn": "Waiting on {actor}",
        "decisionBy": "{decision} by {actor}",
        "stepsComplete": "{approved}/{total} approval steps complete",
        "readyForApproval": "Ready to request approval.",
        "noApprovalRequest": "No approval request has been started yet."
      },
      "intake": {
        "title": "Content brief",
        "heading": "Content brief",
        "stepDescription": "Capture the title and optional planning context before working on channel content.",
        "simple": "Simple content",
        "productionNeeded": "Production needed",
        "contentTitle": "Title",
        "contentTitlePlaceholder": "Name this content item.",
        "clientRequirement": "Client requirement",
        "clientRequirementPlaceholder": "Capture what the client asked for, what prompted the call, and what problem this content should solve.",
        "description": "Description",
        "descriptionPlaceholder": "Describe the content idea, brief, or customer-facing plan.",
        "ideation": "Ideation / brainstorming",
        "ideationPlaceholder": "Raw ideas, angles, examples, hooks, or campaign thoughts.",
        "vibe": "Vibe",
        "vibePlaceholder": "Educational, premium, playful, urgent...",
        "plannedPublishDate": "Planned publish date",
        "targetingHashtags": "Hashtags / targeting",
        "targetingHashtagsPlaceholder": "#localbusiness #launch #behindthescenes",
        "needsProduction": "Needs production work",
        "productionNotes": "Production scope notes",
        "productionNotesPlaceholder": "What needs to be produced, delegated, filmed, edited, designed, or reviewed?"
      },
      "brainstorm": {
        "title": "Brainstorm / Storyboard",
        "heading": "Creative direction",
        "description": "Use this step to align on creative direction before production or content writing.",
        "directionCaptured": "Creative direction captured",
        "emptySummary": "No direction notes yet",
        "creativeAngle": "Creative angle / storyboard",
        "creativeAnglePlaceholder": "Hooks, shot ideas, references, storyboard beats, visual direction, and talking points.",
        "emptyTitle": "Lightweight for now",
        "emptyDescription": "Storyboard notes are saved through the existing ideation and vibe fields until dedicated storyboard persistence is added."
      },
      "composition": {
        "heading": "Channel variants",
        "description": "Write publishable copy, choose media, and preview each selected channel output.",
        "brief": "Brief",
        "vibe": "Vibe",
        "hashtags": "Hashtags",
        "targets": "Targets",
        "copywriting": "Copywriting",
        "channelCustomizations": "{count} channel customization(s)",
        "noChannelsSelected": "No channels selected",
        "selectTarget": "Select a target",
        "hidePreview": "Hide preview",
        "showPreview": "Show preview"
      },
      "schedule": {
        "title": "Planning",
        "heading": "Channel dates",
        "description": "Select the channels for this content and assign a date to each channel.",
        "plannedFor": "Planned for {date}",
        "noPublishDate": "No publish date selected",
        "publishTiming": "Publish dates",
        "scheduledCount": "{scheduled}/{total} scheduled",
        "datedCount": "{scheduled}/{total} dated",
        "empty": "Select one or more channels before assigning dates.",
        "channels": "Channels",
        "channelsHelp": "Choose which configured channels this content is planned for.",
        "noConfiguredChannels": "Add workspace channels before planning content.",
        "targets": "Targets",
        "targetsHelp": "Choose the publish date for each target.",
        "targetTimesAria": "Target publish times",
        "targetDatesAria": "Target publish dates",
        "daySummaryAria": "Publish day summary",
        "unscheduledAria": "Unscheduled target placements",
        "stillNeedsTime": "Still needs a time",
        "day": "Day",
        "date": "Date",
        "time": "Time",
        "hour": "Hour",
        "clear": "Clear",
        "target": "Target",
        "noPostsTimed": "No posts timed for this day.",
        "readyToPublish": "Mark ready to publish"
      },
      "publish": {
        "title": "Publish",
        "description": "Confirm the selected channels and publish dates, then create the scheduled publication handoff.",
        "ready": "Ready to publish",
        "scheduled": "Publication jobs are scheduled.",
        "published": "Content has been published.",
        "action": "Publish",
        "unavailable": "Approval is required before this content can be published."
      },
      "production": {
        "stageTitle": "Production",
        "stageHeading": "Production prerequisites",
        "stageDescription": "Plan the work required before this content can be completed.",
        "notRequiredTitle": "No production work required for this content.",
        "notRequiredDescription": "Add production work if this content requires filming, photos, design, editing, logistics, or tracked deliverables.",
        "addWorkOrder": "Add work order",
        "newRequest": "New production work order",
        "newRequestMeta": "Shoot, design, editing, logistics, or deliverables",
        "create": "Create work order",
        "openRequests": "{open}/{total} work orders open",
        "title": "Production ({type}) - {title}",
        "type": "Type",
        "priority": "Priority",
        "dueDate": "Due date",
        "assignee": "Assignee",
        "unassigned": "Unassigned",
        "requestTitle": "Title",
        "brief": "Brief",
        "save": "Save",
        "cancel": "Cancel",
        "edit": "Edit",
        "addActiveMedia": "Add active media",
        "priorityMeta": "Priority: {priority}",
        "dueMeta": "Due: {due}",
        "commentsMeta": "Comments: {count}",
        "latestMeta": "Latest: {latest}",
        "none": "None",
        "noDeliverable": "No deliverable",
        "internalNote": "Internal note",
        "internalNotePlaceholder": "Add an internal production note...",
        "comment": "Comment",
        "types": {
          "Copy": "Copy",
          "Image": "Image",
          "Video": "Video",
          "Design": "Design",
          "Thumbnail": "Thumbnail",
          "Edit": "Edit",
          "Other": "Other"
        },
        "priorities": {
          "Low": "Low",
          "Normal": "Normal",
          "High": "High",
          "Urgent": "Urgent"
        },
        "statuses": {
          "Requested": "Requested",
          "InProgress": "In progress",
          "InReview": "In review",
          "ChangesRequested": "Changes requested",
          "Accepted": "Accepted",
          "Cancelled": "Cancelled"
        },
        "templates": {
          "video": "Video shoot",
          "videoSummary": "Storyboard, location, talent, capture, edit",
          "photoshoot": "Photoshoot",
          "photoshootSummary": "Shot list, photographer, location, props, edits",
          "design": "Design asset",
          "designSummary": "Creative brief, layout, review, export",
          "editing": "Editing / post-production",
          "editingSummary": "Footage, first cut, revisions, final asset",
          "custom": "Custom request",
          "customSummary": "Start from a blank production brief"
        },
        "checklists": {
          "video": "Checklist:\n- Confirm creative brief\n- Prepare storyboard / shot list\n- Book location\n- Assign videographer\n- Confirm talent\n- Prepare equipment\n- Capture footage\n- Edit first cut\n- Upload final asset\n- Production approval",
          "photoshoot": "Checklist:\n- Confirm shot list\n- Book photographer\n- Book location\n- Prepare products / props\n- Shoot photos\n- Select final shots\n- Edit / retouch\n- Upload final assets\n- Production approval",
          "design": "Checklist:\n- Confirm creative brief\n- Gather brand assets\n- Create first design\n- Internal review\n- Apply revisions\n- Export final asset\n- Upload final asset\n- Production approval",
          "editing": "Checklist:\n- Gather source footage\n- Create first cut\n- Add captions / graphics\n- Internal review\n- Apply revisions\n- Export final version\n- Upload final asset\n- Production approval"
        }
      },
      "gates": {
        "label": "Approval gate",
        "noApprover": "Approver configuration not available yet",
        "stepsComplete": "{approved}/{total} steps complete",
        "noApprovals": "No approvals required",
        "pendingCount": "{count} approval gate(s) need attention",
        "ready": "Approval gates clear",
        "noApprovalRequired": "No approval required for this step.",
        "awaitingDecision": "Awaiting decision.",
        "approved": "Approved.",
        "needsFollowUp": "Needs follow-up.",
        "optionalAction": "Approval is optional for this step.",
        "requiredAction": "Approval is required before this step is clear.",
        "modes": {
          "none": "None",
          "optional": "Optional",
          "required": "Required",
          "multiStep": "Multi-step"
        },
        "status": {
          "notRequired": "Not required",
          "notRequested": "Not requested",
          "pending": "Pending",
          "approved": "Approved",
          "rejected": "Rejected",
          "changesRequested": "Changes requested"
        }
      },
      "readiness": {
        "title": "Readiness",
        "subtitle": "What blocks this content from moving forward.",
        "blockers": "Blockers",
        "blockersCount": "{count} blocker(s)",
        "brief": "Brief",
        "briefReady": "Brief captured",
        "briefMissing": "Brief is missing",
        "titleMissing": "Title is missing",
        "clientRequirementMissing": "Client requirement is missing",
        "productionMissing": "Production is required but no work order exists.",
        "productionOpen": "{title} is not accepted yet.",
        "productionAssigneeMissing": "{title} has no assignee.",
        "productionDueMissing": "{title} has no due date.",
        "deliverableMissing": "{title} has no deliverable.",
        "productionReady": "Production prerequisites are clear",
        "noChannels": "No channels selected",
        "missingTimeFor": "{target} is missing a publish date."
      },
      "approval": {
        "request": "Request approval",
        "decisionAria": "Approval decision",
        "workflowAria": "Approval workflow",
        "title": "Approval",
        "unavailable": "Unavailable",
        "waitingOnYou": "Waiting on you",
        "waitingOnApprover": "Waiting on approver",
        "saveFirst": "Save the content before requesting approval.",
        "modeNone": "This workspace does not require approval.",
        "reviewer": "Reviewer",
        "approver": "Approver",
        "step": "Step {number}",
        "reason": "Reason",
        "reasonPlaceholder": "Add the approval note, rejection reason, or requested changes.",
        "approve": "Approve",
        "changes": "Changes",
        "reject": "Reject",
        "decisionFailed": "The approval decision could not be recorded.",
        "workflow": "Workflow",
        "status": "Status",
        "due": "Due",
        "action": "Action",
        "noDueDate": "No due date",
        "directReviewer": "Direct reviewer",
        "noAction": "No action available",
        "clickToApprove": "Click the circle to approve.",
        "productionTitle": "Production",
        "publicationTitle": "Publication",
        "publishedTitle": "Published",
        "approvalEmpty": "Move this content to In approval to start the configured workflow steps.",
        "noApprovalActivity": "No approval activity yet."
      },
      "collaboration": {
        "title": "Collaboration",
        "empty": "Save the content first to start comments, activity, and history.",
        "noActivity": "No activity has been recorded yet.",
        "noHistory": "No field-level changes have been recorded yet.",
        "to": "to"
      },
      "smartEditor": {
        "bold": "Bold",
        "italic": "Italic",
        "mention": "Mention",
        "hashtag": "Hashtag",
        "emoji": "Emoji",
        "noMatchingMembers": "No matching members",
        "createHashtag": "Create #{tag}",
        "newHashtag": "New hashtag",
        "searchEmojis": "Search emojis"
      }
    }
  },
  "userSettings": {
    "eyebrow": "User information",
    "title": "Profile and identity",
    "description": "Manage the portrait and account details shown inside the workspace.",
    "tabs": {
      "information": "Informations",
      "notifications": "Notifications",
      "calendars": "Calendars"
    },
    "updatePortrait": "Update portrait",
    "accountDetails": "Account details",
    "accountDetailsDescription": "Edit the profile details other workspace members see.",
    "saveDetails": "Save details",
    "saved": "Profile details saved",
    "emailConfirmationSent": "Profile details saved. Check your new email address to confirm the email change.",
    "portraitSaved": "Portrait saved",
    "calendarFeed": {
      "title": "Private calendar feed",
      "description": "Subscribe to your Socialize work dates from external calendar apps.",
      "empty": "The private calendar feed is disabled.",
      "feedUrl": "Subscription URL",
      "enable": "Enable feed",
      "copy": "Copy URL",
      "regenerate": "Regenerate URL",
      "revoke": "Revoke feed",
      "enabled": "Calendar feed enabled",
      "regenerated": "Calendar feed URL regenerated",
      "revoked": "Calendar feed revoked",
      "copied": "Calendar feed URL copied",
      "errors": {
        "copyFailed": "The URL could not be copied.",
        "updateFailed": "The calendar feed could not be updated."
      }
    },
    "notifications": {
      "title": "Notification methods",
      "description": "Choose how workflow notifications reach you.",
      "loading": "Loading notification preferences...",
      "saved": "Notification preference saved",
      "webPushTitle": "Browser push",
      "webPushStatus": "Permission: {status}",
      "enableWebPush": "Enable browser push",
      "webPushEnabled": "Browser push enabled",
      "channels": {
        "InApp": "In-app",
        "Email": "Email",
        "Sms": "SMS",
        "WebPush": "Browser push",
        "NativePush": "Phone push"
      },
      "errors": {
        "loadFailed": "Notification preferences could not be loaded.",
        "saveFailed": "Notification preference could not be saved.",
        "webPushUnsupported": "Browser push is not available in this browser or environment.",
        "permissionDenied": "Browser push permission was not granted.",
        "webPushFailed": "Browser push could not be enabled."
      }
    },
    "alias": "Alias",
    "firstname": "First name",
    "lastname": "Last name",
    "fullName": "Full name",
    "email": "Email",
    "preferredLanguage": "Preferred language",
    "noEmail": "No email set",
    "cropperTitle": "Update user portrait",
    "savePortrait": "Save portrait",
    "choosePortrait": "Choose portrait",
    "errors": {
      "emailRequired": "Email is required.",
      "saveFailed": "Profile details could not be saved.",
      "portraitFailed": "Portrait could not be saved."
    }
  },
  "workspaceSettings": {
    "eyebrow": "Settings",
    "title": "Workspace settings",
    "description": "Configure the current workspace across general details, members, workflow, and social channels.",
    "currentWorkspace": "Current workspace",
    "noWorkspaceSelected": "No workspace selected",
    "activeWorkspace": "Active workspace",
    "contextNote": "These settings apply to the current workspace only.",
    "inviteTitle": "Invite workspace members",
    "inviteDescription": "Invite clients, subcontractors, or teammates into the active workspace.",
    "inviteEmpty": "No pending invites for this workspace yet.",
    "sendInvite": "Send invite",
    "reset": "Reset",
    "errors": {
      "required": "All workspace fields are required.",
      "createFailed": "The workspace could not be created.",
      "updateFailed": "The workspace settings could not be saved.",
      "deleteFailed": "The workspace could not be deleted.",
      "logoUploadFailed": "The workspace logo could not be saved.",
      "inviteRequired": "Email and role are required to invite a member.",
      "emailRequired": "Enter an email address.",
      "emailInvalid": "Enter a valid email address.",
      "inviteFailed": "The workspace invite could not be created.",
      "memberRemoveFailed": "The workspace member could not be removed."
    },
    "fields": {
      "name": "Workspace name",
      "slug": "Workspace slug",
      "slugHint": "Used as the folder name under the organization DAM root.",
      "timeZone": "Time zone",
      "memberEmail": "Member email",
      "memberRole": "Role"
    },
    "roles": {
      "administrator": "Administrator",
      "manager": "Manager",
      "client": "Client reviewer",
      "provider": "Subcontractor",
      "workspace-member": "Workspace member"
    },
    "summary": {
      "name": "Name",
      "timeZone": "Time zone"
    },
    "delete": {
      "kicker": "Danger zone",
      "title": "Delete workspace",
      "description": "Permanently delete this workspace and all of its content, media, messages, approvals, channels, members, and related workflow data.",
      "confirmationLabel": "Type {name} to confirm",
      "confirmationMismatch": "Type the workspace name exactly to delete it.",
      "action": "Delete workspace",
      "deleting": "Deleting workspace"
    },
    "tabs": {
      "general": "General",
      "members": "Members",
      "workflow": "Workflow",
      "channels": "Channels"
    },
    "members": {
      "inviteTitle": "Invite",
      "activeTitle": "Members",
      "activeDescription": "See everyone who currently belongs to the active workspace.",
      "activeEmpty": "No members found for this workspace.",
      "pendingTitle": "Pending invitations",
      "pendingDescription": "Track who has been invited into the active workspace.",
      "resendInvite": "Resend email",
      "cancelInvite": "Cancel invite",
      "editPermissions": "Edit permissions",
      "editRole": "Edit role",
      "removeAction": "Remove member",
      "removeConfirm": "Remove {name} from this workspace?",
      "removed": "Workspace member removed."
    },
    "channels": {
      "title": "Social channel access",
      "description": "Review provider connections, OAuth state, token checks, and missing permissions for workspace channels.",
      "addChannel": "Add Channel",
      "empty": "No workspace channels have been configured yet.",
      "notConnected": "Not connected",
      "connectedAccount": "account connected",
      "accountName": "Account name",
      "platform": "Platform",
      "status": "Status",
      "actions": "Actions",
      "destinationRequired": "Choose a provider destination to create the workspace channel.",
      "chooseDestination": "Choose channel",
      "providerDestination": "Provider destination",
      "tokenExpiry": "Token expiry",
      "noExpiry": "No expiry",
      "expiresInDays": "Expires in {days} days",
      "expiredDaysAgo": "Expired {days} days ago",
      "lastCheck": "Last check",
      "notChecked": "Not checked",
      "permissionDetails": "Permission details",
      "grantedScopes": "Granted permissions",
      "missingScopes": "Missing permissions",
      "none": "None",
      "connectedAccountFallback": "YouTube account",
      "providerAccountFallback": "{provider} account",
      "connect": "Connect",
      "unavailable": "Unavailable",
      "configuredCount": "{count} configured",
      "refresh": "Refresh",
      "reconnect": "Reconnect",
      "verify": "Verify",
      "disconnect": "Disconnect",
      "removeAccount": "Disconnect connection",
      "changeName": "Change name",
      "changeNameDescription": "Update the display name used for this workspace channel.",
      "nameRequired": "A channel name is required.",
      "renameFailed": "The channel name could not be changed.",
      "deleteChannelFailed": "The channel could not be deleted.",
      "providerBrowser": {
        "kicker": "Channel setup",
        "title": "Add a channel",
        "description": "Pick a social network, connect the account, then choose the destination for this workspace.",
        "comingSoon": "Coming soon",
        "oauthNotConfigured": "OAuth not configured"
      },
      "destinations": {
        "title": "Choose the destination to add",
        "description": "Select the destination that this workspace will plan, review, and schedule content for.",
        "connectedAccount": "Connected account",
        "connected": "Already connected",
        "usingAccount": "Using {account}",
        "destination": "Destination",
        "empty": "No destinations were returned for this account. Check the provider permissions, then reconnect the account.",
        "loadFailed": "Provider destinations could not be loaded. Check the provider permissions, then reconnect the account.",
        "connectFailed": "The selected destination could not be connected.",
        "selectedCount": "{count} selected",
        "confirm": "Confirm"
      },
      "providerCategories": {
        "all": "All",
        "social": "Social",
        "videos": "Videos",
        "reviews": "Reviews",
        "business": "Business",
        "analytics": "Analytics",
        "community": "Community",
        "other": "Other"
      },
      "health": {
        "NotConnected": "Not connected",
        "Connected": "Connected",
        "MissingPermissions": "Missing permissions",
        "TokenExpired": "Token expired",
        "ProviderUnavailable": "Provider unavailable",
        "Disconnected": "Disconnected",
        "ActionRequired": "Action required"
      }
    },
    "general": {
      "detailsTitle": "Workspace details",
      "detailsDescription": "Update the workspace name and default time zone used across schedules and workspace views.",
      "saveAction": "Save workspace",
      "saved": "Workspace settings saved."
    },
    "logo": {
      "title": "Workspace logo",
      "description": "Use a local file or remote image, then crop it for the workspace.",
      "changeAction": "Change image",
      "cropperTitle": "Update workspace logo",
      "saveAction": "Save logo",
      "chooseAction": "Choose logo",
      "saved": "Workspace logo saved."
    },
    "approvals": {
      "flowTitle": "Approval flow",
      "flowDescription": "Configure how content approval works across this workspace.",
      "previewTitle": "Flow preview",
      "previewDescription": "This is the sequence the workspace will use based on the current configuration.",
      "saved": "Approval flow saved.",
      "saveAction": "Save approval flow",
      "fields": {
        "approvalMode": "Approval mode",
        "schedulePostsAutomaticallyOnApproval": "Schedule posts automatically on approval",
        "lockContentAfterApproval": "Lock content after approval",
        "sendAutomaticApprovalReminders": "Send automatic approval reminders"
      },
      "fieldHelp": {
        "schedulePostsAutomaticallyOnApproval": "Final approval moves content to Scheduled when it already has a planned publish date.",
        "lockContentAfterApproval": "Approval-controlled content becomes locked after final approval. Scheduling fields remain editable.",
        "sendAutomaticApprovalReminders": "Current approvers receive daily reminders while an approval step is pending."
      },
      "modes": {
        "none": "None",
        "optional": "Optional",
        "required": "Required",
        "multiLevel": "Multi-level"
      },
      "modeHelp": {
        "none": "Content skips approval workflow and can become Approved without approval actions.",
        "optional": "A one-step approval workflow is available but does not block publication workflow.",
        "required": "At least one approval is required before content can become Approved or Scheduled.",
        "multiLevel": "Approval uses ordered steps with targeted approvers for each step."
      },
      "editor": {
        "title": "Multi-level steps",
        "description": "Define who approves each ordered step before content reaches final approval.",
        "addStep": "Add step",
        "empty": "Add at least one approval step before saving multi-level approval.",
        "unnamedStep": "Unnamed step",
        "moveUp": "Move step up",
        "moveDown": "Move step down",
        "removeStep": "Remove step",
        "selectMember": "Select a member",
        "selectMembers": "Select one or more members. Hold Ctrl or Command to select multiple.",
        "defaultStepName": "Approval step {number}",
        "stepNumber": "Step {number}",
        "fields": {
          "name": "Display name",
          "targetType": "Target type",
          "targetValue": "Target",
          "requiredApproverCount": "Required approvers"
        },
        "targetTypes": {
          "role": "Role",
          "membership": "Membership",
          "member": "Member"
        },
        "memberships": {
          "team": "Team",
          "client": "Client"
        },
        "errors": {
          "atLeastOneStep": "Multi-level approval requires at least one step.",
          "fixInvalidSteps": "Fix the highlighted approval steps before saving.",
          "nameRequired": "Enter a step name.",
          "targetRequired": "Choose who can approve this step.",
          "notEnoughMembers": "Select at least as many members as required approvers.",
          "requiredApproverCount": "Enter at least 1 required approver."
        }
      },
      "steps": {
        "none": "Approval skipped",
        "approval": "Approval",
        "publish": "Publishing handoff"
      },
      "stepDetail": {
        "none": "No approval workflow is created for content in this workspace.",
        "optional": "Approval can be collected, but it is not required before publication workflow.",
        "approverCount": "{count} approver(s) required",
        "multiLevelTarget": "{count} approver(s) from {target}",
        "autoSchedule": "Approved content with a planned publish date moves to Scheduled.",
        "manualSchedule": "Approved content remains Approved until scheduling is handled."
      }
    }
  },
  "mediaLibrary": {
    "eyebrow": "Media library",
    "title": "Workspace media",
    "loading": "Loading media library...",
    "uploadFile": "Media file",
    "upload": "Upload",
    "folderName": "Folder name",
    "createFolder": "Create folder",
    "folder": "Folder",
    "download": "Download",
    "rename": "Rename",
    "renameLabel": "New name",
    "linked": "Linked",
    "unlinked": "Unlinked",
    "emptyAssets": "No media files yet.",
    "storage": {
      "used": "Space used",
      "available": "Available on plan",
      "notMetered": "Not metered",
      "sizeUnavailable": "Size unavailable",
      "currentPlan": "Current plan",
      "limit": "{limit} plan limit"
    },
    "metrics": {
      "files": "Files",
      "linkedSummary": "{linked} linked / {unlinked} unlinked"
    },
    "list": {
      "title": "Library",
      "count": "{count} items"
    },
    "details": {
      "linkState": "Link status",
      "size": "Size",
      "updated": "Updated",
      "unavailable": "Unavailable"
    }
  },
  "errors": {
    "unexpected": "An unexpected error occurred",
    "imageLoad": "Error loading image",
    "imageUpload": "Error uploading image"
  }
}
